export const COLORS: any = {
  primaryBlue: '#1676d6',
  darkGrey: '#767687',
  lightBlue: '#9bcaf8',
};
